import { departmentService } from "../../../../Api/Services/DepartmentService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";
import { CreateDepartmentResponse, ICreateDepartmentPayload } from "../../../../Types/Common";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";

export const updateDepartmentThunk = createServiceAsyncThunk<
  CreateDepartmentResponse,
  { id: number; payload: ICreateDepartmentPayload }
>(
  ACTION_NAMES.UPDATE_DEPARTMENT,
  ({ id, payload }) => departmentService.updateDepartment(id, payload),
  ERROR_MESSAGES.UPDATE_DEPARTMENT_FAILURE
);

const updateDepartmentSlice = createGenericSlice<CreateDepartmentResponse, any>(
  SLICE_NAMES.UPDATE_DEPARTMENT,
  updateDepartmentThunk
);

export const {
  clearError: clearUpdateDepartmentError,
  clearSuccessMessage: clearUpdateDepartmentSuccess
} = updateDepartmentSlice.actions;

export default updateDepartmentSlice.reducer;
